(function () {
    let tlFreeGiftOfferClone;
    let notificationClone;
    let embedClone;

    const TRANSLATION =  {
        header: {
            quantity_heading: "Compra al menos {{condition}} para obtener recompensas",
            amount_heading: "Gasta al menos {{condition}} para obtener recompensas",
            badge: "Recompensa Especial",
        },
        upsell_message: {
            not_eligible: "Compra {{remain}} más para desbloquear esta recompensa",
            eligible: "¡Felicidades! Reclama tu recompensa ahora",
            claimed: "Has reclamado tus recompensas",
        },
        main_offer: {
            free_text: "GRATIS",
            select_button: "Seleccionar",
            unselect_button: "Deseleccionar",
            claim_button: "Reclamar oferta",
            countdown_timer: "Faltan {{timer}}",
        },
        selection_hint: {
            not_eligible: "Reclama hasta {{gift_number}} regalos",
            eligible: "Seleccionado(s) {{gift_selected}}/{{gift_number}} regalos",
            claimed: "Reclamado(s) {{gift_number}}/{{gift_number}} regalos",
        },
        toast: {
            err_when_claim: "Ocurrieron algunos errores. No se puede reclamar ahora, por favor inténtalo más tarde.",
            not_choose_enough_gift: "No se han seleccionado suficientes recompensas. Por favor, selecciona más.",
        },
    }

    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(value) {
            if (value && !tlFreeGiftOfferClone) {
                Object.defineProperty(value, "notification", {
                    get() {
                        return notificationClone;
                    },
                    set(newValue) {
                        newValue.createNotiEle = (imageSrc) =>  {
                            const showType = window.tlFreeGiftOffer.notification.displaySettings.image.show_type;
                            const notiEle = document.createElement('div');
                            notiEle.classList.add("salepify-notification-popup", "salepify-notification-popup--hide");
                    
                            notiEle.innerHTML = `
                                <div class="salepify-notification-popup__image"
                                    style="display: ${showType == window.tlFreeGiftOffer.notification.IMAGE_SHOW_TYPE.NO_IMAGE ? "none" : "flex"}"
                                >
                                    ${showType == window.tlFreeGiftOffer.notification.IMAGE_SHOW_TYPE.PRODUCT_IMAGE
                                        ? `<img src="${imageSrc}" />`
                                        : window.tlFreeGiftOffer.notification.ICONS[window.tlFreeGiftOffer.notification.displaySettings.image.icon_index]
                                    }
                                </div>
                                <div class="salepify-notification-popup__content">
                                    <div class="salepify-notification-popup__header">¡Felicidades! Has desbloqueado una recompensa 🎉</div>
                                    <div class="salepify-notification-popup__body">Tu regalo gratuito ya está en tu carrito.</div>
                                </div>
                    
                                <div class="salepify-notification-popup__close-btn" onclick="window.tlNotificationPopup.onClickClosePopup(this)">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.831 13.7803C13.1239 14.0732 13.5988 14.0732 13.8917 13.7803C14.1846 13.4874 14.1846 13.0126 13.8917 12.7197L11.172 10L13.8917 7.28033C14.1846 6.98744 14.1846 6.51256 13.8917 6.21967C13.5988 5.92678 13.1239 5.92678 12.831 6.21967L10.1113 8.93934L7.39166 6.21967C7.09877 5.92678 6.62389 5.92678 6.331 6.21967C6.03811 6.51256 6.03811 6.98744 6.331 7.28033L9.05067 10L6.331 12.7197C6.0381 13.0126 6.0381 13.4874 6.331 13.7803C6.62389 14.0732 7.09877 14.0732 7.39166 13.7803L10.1113 11.0607L12.831 13.7803Z" fill="#4A4A4A"/>
                                    </svg>
                                </div>
                            `;
                            return notiEle;
                        }
                        notificationClone = newValue
                    },
                    configurable: true,
                });

                Object.defineProperty(value, "embedWidget", {
                    get() {
                        return embedClone;
                    },
                    set(newValue) {
                        //Add css to hide old embed widget
                        const style = document.createElement('style');
                        style.innerHTML = `
                            product-form .salepify-embed-widget__container:last-child {
                                display: none !important;
                            }
                        `;
                        document.head.appendChild(style);

                        // Define new class extends tlEmbedWidget
                        class newEmbedClass extends tlEmbedWidget {
                            constructor(...args) {
                                super(...args);
                            }

                            getTranslation(translations) {
                                return TRANSLATION;
                            }
                        };
                        
                        const constants = tlFreeGiftConstant();
                        const tl = {
                            constants,
                            utils: tlFreeGiftUtils(constants, window.tlFreeGiftData.moneyFormat),
                            services: tlFreeGiftServices(constants),
                            customize: tlFreeGiftCustomization()
                        };
                        // Create new instant
                        embedClone = new newEmbedClass({...window.tlFreeGiftData, ...tl})
                    },
                    configurable: true,
                });

                tlFreeGiftOfferClone = value;
            }
        },
        configurable: true,
    });
})();